import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { EntiteModel } from "src/app/models/entites/entite.model";
import { EntitesService } from "src/app/services/entites/entites.service";
import { ExportComptableService } from "src/app/services/export-comptable.service";

@Injectable({ providedIn: 'root' })
export class ExportComptableResolver implements Resolve<boolean> {
  constructor(
    private entitesService: EntitesService,
    private exportComptableService: ExportComptableService
  ) {}

  resolve(): Observable<boolean> {
    return this.entitesService.getSelectedEntiteDeTravail().pipe(
      switchMap((entite: EntiteModel) =>
        this.exportComptableService.getIsExportCorrect(entite.id).pipe(
          map((res: any) => res.isCorrect)
        )
      ),
      catchError(() => of(true))
    );
  }

}
